import React from 'react';
import { connectSortBy } from 'react-instantsearch-dom';

import { MenuItem, IconMenu, IconButton } from 'material-ui';
import SortIcon from 'material-ui/svg-icons/content/sort';

class MaterialUiSortBy extends React.Component {
  render() {
    return (
      <IconMenu
        iconButtonElement={
          <IconButton>
            <SortIcon color="white" style={{ marginTop: 13 }} />
          </IconButton>
        }
        onChange={this.handleChange}
        value={this.props.currentRefinement}
      >
        {this.props.items.map(item => (
          <MenuItem
            key={item.value}
            value={item.value}
            primaryText={item.label}
            onClick={() => {
              this.props.refine(item.value);
            }}
          />
        ))}
      </IconMenu>
    );
  }
}

const ConnectedSortBy = connectSortBy(MaterialUiSortBy);
export default ConnectedSortBy;



// WEBPACK FOOTER //
// ./src/components/Algolia/ConnectedSortBy.js